import { render, staticRenderFns } from "./Farmslist.vue?vue&type=template&id=f8764ab8&"
import script from "./Farmslist.vue?vue&type=script&lang=js&"
export * from "./Farmslist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports